import React from 'react';

export default function boldText(value) {
	return value.split(/(<strong>.*?<\/strong>)/g).map((segment, index) => {
		if (segment && `${segment}`.match(/<strong>(.*?)<\/strong>/g)) {
			const capturedSubstring = segment.replace(/<\/?strong>/g, '');
			return <strong key={index}>{capturedSubstring}</strong>;
		} else {
			return <span key={index}>{segment}</span>;
		}
	});
}
